import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ConceptoPolizaContableList } from "./conceptos";

type Entity = models.PolizaContableDto;
export interface Props {
    value: Entity;
}


/**
* Componente para editar un Entity
*/
export class PolizaContableFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    getField = formfields(() => ({ ... this.props, readonly: true }));

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Number = getField(kea.Number);
        const Date = getField(kea.DateTime);
        const Tipo = getField(selectores.TipoPolizaContable);
        const Estado = getField(selectores.EstadoPolizaContable);
        const Origen = getField(selectores.OrigenPolizaContable);

        const Conceptos = getField(ConceptoPolizaContableList);
        return (
            <div>
                <kea.Title titulo="Póliza contable" onRegresar={() => history.go("../")} />
                {kea.autogrid(3, [
                    <Text field="NombreSucursal" label="Sucursal" />,
                    <Date time field="FechaCreacion" label="Fecha de creación" />,
                    <Date time field="FechaPoliza" label="Fecha poliza" />,
                    <Tipo field="TipoPoliza" label="Tipo" />,
                    <Estado field="EstadoPoliza" label="Estado" />,
                    <Origen field="Origen" label="Origen" />,
                    <Text field="SerieFolioFactura" label="Folio factura" />,
                    <Text field="UUIDFactura" label="UUID factura" />,
                    <Text field="IdSistemaContabilidad" label="Id sistema contabilidad" />,
                    <Number field="Cargos" label="Cargos" />,
                    <Number field="Abonos" label="Abonos" />,
                ])}
                <Text field="Concepto" label="Concepto" multiline />,

                <Conceptos field="Conceptos" />
            </div>);
    }
}

export const PolizaContableForm = componentToRx(PolizaContableFormNoRx);




// WEBPACK FOOTER //
// ./app/features/general/operativa/items/polizas/edit/form.tsx